module.exports = __webpack_public_path__ + "static/img/derivation-ticket.6d19720.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/derivation-ticket.svg
// module id = oxUr
// module chunks = 31